/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import CloseIcon from "@mui/icons-material/Close";

import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";

import {
  getPicklistAgeingReportHome,
  getExpandedPicklistReportHome,
} from "../../store";
import DataTable from "examples/Tables/DataTable";

import Cookies from "universal-cookie";
import { token } from "stylis";
const cookies = new Cookies();

const PdiPicklistHomePageCard = ({
  getPicklistAgeingReportHome,
  getPicklistAgeingReportHomeReducer,
  getExpandedPicklistReportHome,
  getExpandedPicklistReportHomeReducer,
}) => {
  const [picklistTitle, setPicklistTitle] = useState("");
  const [picklistData, setPicklistData] = useState([]);
  const [picklistAgeingData, setPicklistAgeingData] = useState([]);
  const [expandedPicklistData, setExpandedPicklistData] = useState([]);

  const loginDetails = cookies.get("loginDetailsForWMS");
  const jwtToken = loginDetails?.jwt;

  useEffect(() => {
    if (jwtToken) {
      getPicklistAgeingReportHome(jwtToken);
      getExpandedPicklistReportHome(jwtToken);
    }
  }, []);

  useEffect(() => {
    const data =
      getPicklistAgeingReportHomeReducer?.picklistAgeing?.picklistAging ?? [];

    setPicklistData(data);
    setPicklistTitle("Picklist Ageing Report");
  }, [getPicklistAgeingReportHomeReducer]);

  useEffect(() => {
    // getExpandedPicklistReportHome(jwtToken);
  }, []);

  useEffect(() => {
    const expandData =
      getExpandedPicklistReportHomeReducer?.expandedPicklist?.data ??
      getExpandedPicklistReportHomeReducer?.expandedPicklist ??
      [];

    setExpandedPicklistData(expandData);
  }, [getExpandedPicklistReportHomeReducer]);

  const styleForStationModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, lg: 1100 },
    boxShadow: 24,
    p: 0,
    pt: 3,
  };

  const chartData = {
    labels: picklistData ? picklistData.map((data) => String(data.value)) : [],
    datasets: {
      label: "Picklist Ageing",
      data: picklistData ? picklistData.map((data) => Number(data.count)) : [],
      backgroundColor: "rgba(153, 102, 255, 0.2)",
      borderColor: "rgba(153, 102, 255, 1)",
      borderWidth: 1,
    },
  };

  //   labels: ["2hr", "1 Day", "1 Week", "1 Month"],
  //   datasets: {
  //     label: "Efficiency",
  //     data: [30, 60, 90, 120],
  //   },

  //   title: "Picklist Ageing ",
  // };

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Empty",
      value: 1,
    },
    {
      label: "Occupied",
      value: 0,
    },
  ];
  const [state, setState] = useState({
    columns: [
      // { Header: "Picklist", accessor: "assembly" },
      // { Header: "Doc", accessor: "assemblyType" },
      // { Header: "Qty", accessor: "warehouse" },
      // { Header: "update", accessor: "zone" },
      // {
      //   Header: "suid",
      //   accessor: "isEmpty",
      //   searchType: "select",
      //   selectOptions: statusOptions,
      //   placeholder: "All Status",
      //   cannotSort: true,
      // },
    ],
    rows: [
      // {
      //   assembly: "PL-001",
      //   assemblyType: "Doc-001",
      //   warehouse: 100,
      //   zone: "Zone A",
      //   isEmpty: "Available",
      //   action: "Edit",
      // },
      // {
      //   assembly: "PL-002",
      //   assemblyType: "Doc-002",
      //   warehouse: 50,
      //   zone: "Zone B",
      //   isEmpty: "Not Available",
      //   action: "Edit",
      // },
      // {
      //   assembly: "PL-003",
      //   assemblyType: "Doc-003",
      //   warehouse: 75,
      //   zone: "Zone C",
      //   isEmpty: "Available",
      //   action: "Edit",
      // },
    ],
  });

  const picklistColumns = [
    { Header: "Picklist Code", accessor: "picklistCode" },
    { Header: "Document No.", accessor: "documentNumber" },
    { Header: "Item Code", accessor: "itemCode" },
    { Header: "Picklist Qty", accessor: "picklistQty" },
    { Header: "SU Qty", accessor: "suQty" },
    { Header: "Created Date", accessor: "createdDate" },
  ];

  useEffect(() => {
    const rawPicklistData =
      getExpandedPicklistReportHomeReducer?.expandedPicklist?.data ?? [];

    const formattedPicklistRows = Array.isArray(rawPicklistData)
      ? rawPicklistData.map((item) => ({
          picklistCode: item.picklistCode,
          documentNumber: item.documentNumber,
          itemCode: item.itemCode,
          picklistQty: item.picklistQty,
          suQty: item.suQty,
          createdDate: item.createdDate ? item.createdDate.slice(0, 10) : "",
        }))
      : [];

    setState((prev) => ({
      ...prev,
      picklistRows: formattedPicklistRows,
    }));
  }, [getExpandedPicklistReportHomeReducer]);

  // const { picklistRows } = state;

  // const { columns, rows } = state;

  const [open, setOpen] = useState(false);

  // Open the dialog
  const handleOpen = () => {
    setOpen(true);
  };

  const [stationModal, setOpenStationModal] = useState(false);

  const handleOpenStationModal = () => {
    setOpenStationModal(true);
  };
  const handleCloseStationModal = () => {
    setOpenStationModal(false);
  };
  // Close the dialog

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const styles = {
    iconButton: {
      marginLeft: "10px",
      padding: "12px",
      borderRadius: "50%",
      backgroundColor: isHovered ? "#000000" : "#000000",
      color: "white",
      boxShadow: isFocused
        ? "0 0 0 4px rgba(38, 143, 255, 0.5)"
        : "0 4px 12px rgba(0, 123, 255, 0.3)",
      transition: "all 0.3s ease-in-out",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isHovered ? "scale(1.1)" : "scale(1)",
    },
  };

  return (
    // <ReportsBarChart
    //   color="primary"
    //   chart={chartData}
    //   // description="* in days"
    // />
    <>
      <ReportsBarChart
        color="dark"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}
            >
              {picklistTitle}
            </span>
            <IconButton
              style={styles.iconButton}
              onClick={handleOpenStationModal} // Enable modal on click
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              aria-label="Expand"
            >
              <AspectRatioIcon />
            </IconButton>
          </div>
        }
        chart={chartData}
      />

      <Modal
        open={stationModal}
        onClose={handleCloseStationModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDCard sx={styleForStationModal}>
          <MDBox ml={3} mt={-1} display="flex" alignItems="center">
            <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
              Picklist
            </MDTypography>

            <MDBox display="flex" marginLeft="auto">
              <span>
                {/* <Tooltip title="Close"> */}
                <IconButton
                  style={{
                    display: "flex",
                    background: "whitesmoke",
                    color: "black",
                    borderRadius: 5,
                    marginLeft: "auto",
                    marginBottom: "5px",
                    marginRight: "10px",
                  }}
                  aria-label="close"
                  color="inherit"
                  onClick={handleCloseStationModal}
                >
                  <CloseIcon />
                </IconButton>
                {/* </Tooltip> */}
              </span>
            </MDBox>
          </MDBox>
          <hr style={{ marginBottom: "1rem" }} />
          <MDBox>
            {/* {loading ? ( */}
            <DataTable
              table={{
                columns: picklistColumns,
                rows: state.picklistRows ?? [],
              }}
              isSorted={true}
              tableSearch={true}
              entriesPerPage={{
                defaultValue: 5,
                entries: [5, 10, 15, 20, 25, 30],
              }}
              showTotalEntries={true}
              noEndBorder
              hideColumns={["updatedDate"]}
            />
          </MDBox>
        </MDCard>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    // pdi: state.getPdiHomePage,
    getPicklistAgeingReportHomeReducer:
      state.getPicklistAgeingReportHomeReducer,
    getExpandedPicklistReportHomeReducer:
      state.getExpandedPicklistReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getPdi: () => dispatch(getPdi()),
    getPicklistAgeingReportHome: (token) =>
      dispatch(getPicklistAgeingReportHome(token)),
    getExpandedPicklistReportHome: (token) =>
      dispatch(getExpandedPicklistReportHome(token)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdiPicklistHomePageCard);
